import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useV1MarketplaceStoresCreate,
  useV1MarketplaceStoreFamiliesCreate,
  useV1MarketplaceStoreRevisionsCreate,
  useV1MarketplaceStoreRevisionsPublishCreate,
} from "@/api/generated/v1/v1";
import { PageBanner } from "@/shared/components/PageBanner";

export function StoreCreatePage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    seller_organization_id: "",
    store_code: "",
    branding_json: "{}",
    visibility_settings_json: "{}",
  });

  const { mutateAsync: createStore } = useV1MarketplaceStoresCreate();
  const { mutateAsync: createFamily } = useV1MarketplaceStoreFamiliesCreate();
  const { mutateAsync: createRevision } = useV1MarketplaceStoreRevisionsCreate();
  const { mutateAsync: publishRevision } = useV1MarketplaceStoreRevisionsPublishCreate();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      // 1. Create Store (Organization link)
      const storeRes: any = await createStore({
        data: { seller_organization_id: formData.seller_organization_id },
      });
      const storeId = storeRes.id || storeRes.data?.id;

      // 2. Create Store Family
      const familyRes: any = await createFamily({
        data: { store: storeId, store_code: formData.store_code },
      });
      const familyId = familyRes.id || familyRes.data?.id;
      
      // 3. Create Store Revision
      const revisionRes: any = await createRevision({
        data: {
          family: familyId,
          branding_json: JSON.parse(formData.branding_json || "{}"),
          visibility_settings_json: JSON.parse(formData.visibility_settings_json || "{}"),
        },
      });
      const revisionId = revisionRes.id || revisionRes.data?.id;

      // 4. Publish Store Revision
      await publishRevision({ id: revisionId, data: {} as any });

      navigate("/marketplace/stores");
    } catch (err: any) {
      console.error(err);
      setError("خطا در ایجاد فروشگاه. لطفاً مقادیر را بررسی کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="ایجاد فروشگاه جدید"
        subtitle="با استفاده از این فرم، یک فروشگاه جدید (Store + Family + Revision) ایجاد و منتشر می‌شود."
        icon="🏪"
        helpLink="/help/marketplace/store-create"
      />
      
      {error && <div style={{ color: "red", marginBottom: "16px" }}>{error}</div>}

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        
        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>شناسه سازمان فروشنده (Seller Organization ID)</label>
          <input
            className="input-field"
            name="seller_organization_id"
            value={formData.seller_organization_id}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>کد فروشگاه (Store Code)</label>
          <input
            className="input-field"
            name="store_code"
            value={formData.store_code}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>تنظیمات برندینگ (JSON)</label>
          <textarea
            className="input-field"
            name="branding_json"
            value={formData.branding_json}
            onChange={handleChange}
            rows={3}
            style={{ width: "100%" }}
            placeholder="{}"
          />
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px" }}>تنظیمات نمایش (JSON)</label>
          <textarea
            className="input-field"
            name="visibility_settings_json"
            value={formData.visibility_settings_json}
            onChange={handleChange}
            rows={3}
            style={{ width: "100%" }}
            placeholder="{}"
          />
        </div>

        <button type="submit" disabled={isLoading} className="btn-primary" style={{ marginTop: "16px" }}>
          {isLoading ? "در حال ایجاد..." : "ایجاد و انتشار فروشگاه"}
        </button>
      </form>
      </div>
    </div>
  );
}
